document.addEventListener("DOMContentLoaded", function () {
	// Show/hide password functionality
	const passwordInputs = document.querySelectorAll('input[type="password"]');

	passwordInputs.forEach(function (passwordInput) {
		const button = document.createElement("a");

		button.title = bds_theme.strings.show_password;
		button.className = "show-password-button";
		button.href = "#";

		button.addEventListener("click", function (event) {
			event.preventDefault();

			if (passwordInput.type === "password") {
				passwordInput.type = "text";
				button.classList.add("active");
				button.title = bds_theme.strings.hide_password;
			} else {
				passwordInput.type = "password";
				button.classList.remove("active");
				button.title = bds_theme.strings.show_password;
			}
		});

		// Insert button after password input
		passwordInput.parentNode.appendChild(button);
	});

	// Auto-submit functionality for select inputs
	const autoSubmitInputs = document.querySelectorAll('select[name="sortby"]');

	autoSubmitInputs.forEach(function (autoSubmitInput) {
		autoSubmitInput.addEventListener("change", function (event) {
			event.preventDefault();
			const form = autoSubmitInput.closest("form");
			if (form) {
				form.submit();
			}
		});
	});
});
